export default function SplitPanelHeader({ left, right }) {
  return (
    <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center">
      {left}
      {right}
    </div>
  );
}
